import React, { useEffect, useState, useCallback, useRef } from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core'
import { get as getCookie, set as setCookie } from 'es-cookie'
import { useDispatch, useSelector } from 'react-redux'
import { CollectionCard, CollectionHeader } from './components'
import CollectionEmptyState from 'src/components/collection-empty-state'
import { getCollectionList } from 'src/reducers/collection/action'
import { Typography } from '@material-ui/core'

const useDebounce = (callback, delay) => {
  const timeoutRef = useRef(null)

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return (...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      callback(...args)
    }, delay)
  }
}

const Collections = ({ classes }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [open, setOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [sortOption, setSortOption] = useState('created_date_desc')
  const [hasFetched, setHasFetched] = useState(false)

  const fetchCollections = useCallback(
    (search = '', sort = 'created_date_desc') => {
      // Parse sort option to determine sortingColumn and direction
      let sortingColumn = ''
      let asc = false

      if (sort.includes('created_date')) {
        sortingColumn = 'createdAt'
        asc = sort === 'created_date_asc'
      } else if (sort.includes('name')) {
        sortingColumn = 'collectionName'
        asc = sort === 'name_asc'
      }

      const query = {
        filterText: search,
        currentPage: 0,
        pageSize: 100,
        sortingColumn: sortingColumn,
        asc: asc,
      }

      setLoading(true)
      dispatch(
        getCollectionList(query, () => {
          setLoading(false)
          setHasFetched(true)
        }),
      )
    },
    [dispatch],
  )

  const debouncedFetchCollections = useDebounce(fetchCollections, 500)

  useEffect(() => {
    fetchCollections()
  }, [fetchCollections])

  const list = useSelector(state => state.collection.list)

  useEffect(() => {
    if (
      getCookie('redirectUrl') != '' &&
      getCookie('redirectUrl') != null &&
      getCookie('redirectUrl') != undefined
    ) {
      window.location.href = getCookie('redirectUrl')
      setCookie('redirectUrl', '')
    }
    setLoading(false)
  }, [dispatch])

  const handleRefresh = (search = searchTerm, sort = sortOption) => {
    setSearchTerm(search)
    setSortOption(sort)
    if (search === '') {
      fetchCollections(search, sort)
    } else {
      debouncedFetchCollections(search, sort)
    }
  }

  const collectionExists = list.length > 0

  return (
    <div className={classes.root}>
      <div className={classes.contentWrapper}>
        <CollectionHeader
          onSearch={setSearchTerm}
          onSort={setSortOption}
          onRefresh={handleRefresh}
          searchTerm={searchTerm}
          sortOption={sortOption}
        />
        {hasFetched && !collectionExists && !loading ? (
          searchTerm ? (
            <div className={classes.noCourses}>
              <img alt="no collections view" src="/assets/404-collection.svg" />
              <Typography className={classes.noCoursesText}>
                No <span className={classes.blueText}>collection</span> found
                matching your search.
              </Typography>
              <Typography className={classes.noCoursesDescriptionText}>
                Try adjusting your search terms or browse all collections.
              </Typography>
            </div>
          ) : (
            <CollectionEmptyState />
          )
        ) : (
          <div className={classes.collectionsGrid}>
            {list.map(collection => (
              <CollectionCard
                key={collection.id}
                collection={collection}
                collections={list}
                refresh={() => handleRefresh()}
                open={open}
                setOpen={setOpen}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default withStyles(styles)(Collections)
